// import React from "react";
// import "../styleSheets/nav.css"
// const NavBar = () => {
//     return (
//         <nav className="navbar">
//              <div className="navbar-left">
//                  <a href="/">
//                  <img src="/image/logo.png" alt="logo" />
//                  </a>
//              </div>
//             <div className="navbar-right">
//                 <a className="menu" href = "/">Home</a>
//                 <a className="menu" href ="/about_page">About TLSAction</a>
//                 <a className="menu" href ="/credit_page">Credits</a>
//                 <a className={"menu"} href="#contact">Contact</a>
//
//             </div>
//         </nav>
//     );
// };
//
// export default NavBar;
import React, { useState } from "react";
import "../styleSheets/nav.css";

const NavBar = () => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleMenu = () => setIsOpen(prev => !prev);
    const closeMenu = () => setIsOpen(false);

    return (
        <nav className="navbar">
            <div className="navbar-left">
                <a href="/" onClick={closeMenu}>
                    <img src="/image/logo.png" alt="logo" />
                </a>
            </div>

            {/* Hamburger button (only visible on mobile via CSS) */}
            <button
                className={`navbar-toggle ${isOpen ? "open" : ""}`}
                onClick={toggleMenu}
                aria-label="Toggle navigation"
                aria-expanded={isOpen}
            >
                <span></span>
                <span></span>
                <span></span>
            </button>

            <div className={`navbar-right ${isOpen ? "open" : ""}`}>
                <a className="menu" href="/" onClick={closeMenu}>Home</a>
                <a className="menu" href="/about_page" onClick={closeMenu}>About TLSAction</a>
                <a className="menu" href="/credit_page" onClick={closeMenu}>Credits</a>
                <a className="menu" href="#contact" onClick={closeMenu}>Contact</a>
            </div>
        </nav>
    );
};

export default NavBar;